import React from "react";
import qLogo from "../../../assets/qlogo.png"

export default function Logo(){
    return (<img src={qLogo} alt="Log" width={67} height={34}/>);
}